import { User } from "@fairfleet/geotab";

/**
 * The groups a user belongs to for role checks: the data-access groups and the report groups
 * ("Zusätzlich die Berichterstattung von diesen Gruppen ermöglichen"). Customers put the
 * Fairfleet role groups into the report groups so the data access stays narrow.
 */
export function userGroupIds(user: Pick<User, "companyGroups" | "reportGroups"> | null | undefined): string[] {
  return [...(user?.companyGroups ?? []), ...(user?.reportGroups ?? [])].map(group => group.id);
}
